import { render, staticRenderFns } from "./classSelection.vue?vue&type=template&id=d54ff24c&scoped=true"
import script from "./classSelection.vue?vue&type=script&lang=js"
export * from "./classSelection.vue?vue&type=script&lang=js"
import style0 from "./classSelection.vue?vue&type=style&index=0&id=d54ff24c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54ff24c",
  null
  
)

export default component.exports